module.exports = __webpack_public_path__ + "img/boardBg.5747bc91.jpg";